import { render, staticRenderFns } from "./TraingameSeting.vue?vue&type=template&id=5270c81e&scoped=true"
import script from "./TraingameSeting.vue?vue&type=script&lang=js"
export * from "./TraingameSeting.vue?vue&type=script&lang=js"
import style0 from "./TraingameSeting.vue?vue&type=style&index=0&id=5270c81e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5270c81e",
  null
  
)

export default component.exports